/**
 * badge.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, Input } from "@angular/core";
import { ReportStep } from "../algorithms/structure/report-step";
import { Badge } from "./badge";
import { BadgeService } from "./badge.service";

@Component({
  selector: "badge",
  template: `
    <span *ngIf="badge.knownType">
      <img
        [src]="badge?.url"
        [class]="badge?.overlay">
      <img
        *ngIf="badge?.overlay && badge?.overlayUrl"
        [src]="badge?.overlayUrl"
        class="overlay">
    </span>
    <span
      *ngIf="!badge?.knownType"
      class="cell notConfigured">
        no badge
    </span>
`,
  styles: [
    `:host {
      display: inline-block;
      position: relative;
      width: 48px;
      height: 48px;
    }`,
    `.cell {
      display: table-cell;
      text-align: center;
      vertical-align: middle;
    }`,
    `img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
    img.ineligible, img.information {
      -webkit-filter: saturate(0%) blur(0.3px);
      filter: saturate(0%) blur(0.3px);
    }
    img.DEBUG {
      -webkit-filter: hue-rotate(215deg) blur(1px);
      filter: hue-rotate(215deg) blur(1px);
    }
    img.overlay {
      z-index: 5;
    }
    img.inexact + .overlay {
      filter: invert(100%) drop-shadow(0px 0px 3px black);
    }`,
    `.imgMissing {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
    }
    .notConfigured {
      position: relative;
      overflow: hidden;
      width: 48px;
      height: 48px;
      background-color: rgba(0, 128, 128, 0.6);
      color: white;
      font-size: 0.8em;
      border-radius: 0.5em;
    }`
  ]
})
export class BadgeComponent
{
  @Input() public set report (step : ReportStep)
  {
    if (!(step instanceof ReportStep))
    {
      throw new Error("Badge report attribute must be a ReportStep object!");
    }
    this.badge = this.badges.get(step.name);
  }

  public badge : Badge;

  constructor (protected badges : BadgeService)
  {
    /* Nothing. */
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/intake-form/badge.component.ts